import React, { Component } from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { Typography, PageHeader, Tag, Table, Form, Input , Button, Alert, Tooltip, Avatar, Space } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import firebase from 'firebase/app';

import CenteredSpinner from '../../../components/CenteredSpinner';
import StrikeClientModel from '../../../models/StrikeClientModel';


const { Paragraph, Text } = Typography;

export default class ManageAccessScreen extends Component {
  constructor(props) {
    super(props);

    const clientId = this.props.match.params.clientId;
    const isAdmin = !!props.isAdmin;
    this.clientModel = new StrikeClientModel({ viewModel: this, clientId, isAdmin });

    this.state = {
      clientId: clientId,
      client: null,
      loading: true,
      loadingDelegatedUsers: true,
      loadingInvitedUsers: true,
      mode: 'viewing',
    };
  }

  componentDidMount() {
    this.clientModel.waitForClientData();

    // Live subscriptions, not one-time gets: when an invite is accepted the
    // person moves from Invited to Active ON SCREEN — the invited_users doc
    // flips to status:'used' (drops from Invited) as delegated_users gains a
    // doc (joins Active). No refresh, no tab-switching.
    this.subscribeActiveDelegateUsers();
    this.subscribeInvitedDelegateUsers();
  }

  componentWillUnmount() {
    if(this.clientModel) this.clientModel.stop();
    if(this.unsubscribeActive) this.unsubscribeActive();
    if(this.unsubscribeInvited) this.unsubscribeInvited();
  }

  componentDidUpdate() {
  }

  subscribeActiveDelegateUsers = () => {
    const db = firebase.firestore();
    this.unsubscribeActive = db.collection('clients').doc(this.state.clientId).collection('delegated_users')
      .onSnapshot((querySnapshot) => this.onDelegatedUsers(querySnapshot),
        (err) => console.warn('[ManageAccess] delegated_users listen failed:', err && err.message));
  }

  onDelegatedUsers = (querySnapshot) => {

    const delegatedUsers = [];

    querySnapshot.docs.forEach((doc, index) => {
      const delegatedUser = doc.data();
      delegatedUser.key = index;
      delegatedUser.userId = doc.id;
      delegatedUsers.push(delegatedUser);
    });
    
    this.setState({ 
      delegatedUsers,
      loadingDelegatedUsers: false,
    });
  }

  subscribeInvitedDelegateUsers = () => {
    const db = firebase.firestore();
    this.unsubscribeInvited = db.collection('clients').doc(this.state.clientId).collection('invited_users')
      .onSnapshot((querySnapshot) => this.onInvitedUsers(querySnapshot),
        (err) => console.warn('[ManageAccess] invited_users listen failed:', err && err.message));
  }

  onInvitedUsers = (querySnapshot) => {

    const invitedUsers = [];

    querySnapshot.docs.forEach((doc, index) => {
      const invitedUser = doc.data();
      invitedUser.key = index;
      invitedUser.inviteId = doc.id;
      const { status } = invitedUser;

      if(status !== 'used') {
        invitedUsers.push(invitedUser);
      }
    });
    
    this.setState({ 
      invitedUsers,
      loadingInvitedUsers: false,
    });
  }

  removeDelegateUser = async (record) => {
    const result = window.confirm(`This will remove ${record.email}'s access to this account and its tags. Are you sure?`);

    if (result) {
      const userId = record.userId;

      const db = firebase.firestore();
      await db.collection('clients').doc(this.state.clientId).collection('delegated_users').doc(userId).delete();
      // The live subscription renders the removal — nothing to refetch.
    }
  }

  removeInvitedUser = async (record) => {
    const result = window.confirm(`This will invalidate the invite to ${record.email}. Are you sure?`);

    if (result) {
      const inviteId = record.inviteId;

      const db = firebase.firestore();
      await db.collection('clients').doc(this.state.clientId).collection('invited_users').doc(inviteId).delete();
      // The live subscription renders the removal — nothing to refetch.
    }
  }

  foundClient = async (client) => {
    this.setState({
      client,
      loading: false,
    });
  }

  clientNotFound = () => {
    this.setState({
      loading: false,
      clientNotFound: true,
    });
  }

  changeMode = (mode) => {
    if (mode === 'viewing') {
      return 'inviting'
    } else if (mode === 'inviting') {
      return 'saving'
    } else {
      return 'viewing';
    }
  }

  onClickEdit = () => {
    this.setState((state) => {
      return {
        mode: this.changeMode(state.mode)
      }
    });
  }

  doneSaving = () => {

    this.setState((state) => {
      return {
        mode: this.changeMode(state.mode)
      }
    });

    this.model.waitForClientData();
  }

  internalSave = async (data) => {
    await this.model.commit(data);
    this.doneSaving();
  }

  onClickInvite = () => {
    this.setState({
      mode: 'inviting',
    });
  }

  onClickCancel = () => {
    console.log(`onClickCancel`);

    this.setState({
      mode: 'viewing',
    });
  }

  getButtons = () => {
    if (this.state.mode === 'viewing') {
      return [
        <Button key="1"  type="text" shape='circle' icon={<PlusCircleOutlined style={{ fontSize: '28px', color :'#070'}}/>} onClick={this.onClickInvite} />
      ]
    } else if (this.state.mode === 'inviting') {
      return [
        <Button key="1" type="danger" onClick={this.onClickCancel}>
          Cancel
        </Button>,
      ];
    } else {
      return [];
    }
  }

  doesContainEmail(array, email) {
    for (const object of array) {
      if (object.email === email) return true;
    }

    return false;
  }

  onFinish = async (values) => {
    const invitedEmail = values.email;
    const alreadyInvited = this.doesContainEmail(this.state.invitedUsers, invitedEmail);

    if (alreadyInvited) {
      window.alert(`${invitedEmail} already has a pending invite to your client account`);
      return;
    }

    const alreadyDelegateUser = this.doesContainEmail(this.state.delegatedUsers, invitedEmail);
    
    if (alreadyDelegateUser) {
      window.alert(`${invitedEmail} is already an active user on your client account`);
      return;
    }

    this.setState((state) => {
      return {
        mode: this.changeMode(state.mode),
      }
    });

    const db = firebase.firestore();
    await db.collection("clients").doc(this.state.clientId).collection("invited_users").add({
      email: invitedEmail,
      invitedAt: firebase.firestore.Timestamp.now(),
      clientDisplayName: this.state.client.displayName,
      clientId: this.state.clientId,
    });

    this.setState((state) => {
      return {
        mode: this.changeMode(state.mode),
      }
    });
    // The live subscription shows the new invite (and its Account status as
    // soon as the server stamp resolves) — nothing to refetch.
  };

  render() {
    const delegatedUsersDataSource = this.state.delegatedUsers;

    const usersColumns = [
      {
        title: 'User',
        key: 'user',
        render: (text, record) => (
          <Space>
            {record.avatar
              ? <Avatar src={record.avatar} />
              : <Avatar>{`${record.displayName || record.email || 'U'}`.charAt(0).toUpperCase()}</Avatar>}
            <span>
              <div style={{ fontWeight: 600 }}>{record.displayName || record.email}</div>
              {record.displayName && <div style={{ fontSize: 12, color: '#888' }}>{record.email}</div>}
            </span>
          </Space>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <span>
            <a onClick={() => { this.removeDelegateUser(record)} }>Remove</a>
          </span>
        ),
      },
    ];

    const invitedUsersDataSource = this.state.invitedUsers;

    const invitedUsersColumns = [
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        // invitedUserId is stamped server-side when the invite is created: the
        // invited email is resolved against Firebase Auth (tombstone-safe — only
        // a live account counts). It tells the inviter what to expect next.
        title: 'Account',
        key: 'account',
        render: (text, record) => {
          if (record.invitedUserId === undefined) {
            return <Tag>Checking…</Tag>;
          }
          return record.invitedUserId
            ? (
              <Tooltip title="This email already signs in to Strikepay — they can accept straight away.">
                <Tag color="green" data-testid="invite-ready">Ready to accept</Tag>
              </Tooltip>
            )
            : (
              <Tooltip title="No Strikepay sign-in uses this email yet. They'll sign up with this exact email first, then the same invite link works.">
                <Tag color="orange" data-testid="invite-needs-signup">Will need to sign up</Tag>
              </Tooltip>
            );
        },
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <span>
            <a onClick={() => {this.removeInvitedUser(record)} }>Uninvite</a>
          </span>
        ),
      },
    ];

    if (this.state.mode === 'viewing') {
      return (
        <>
          <PageHeader
            ghost={false}
            title={`Manage access`}
            onBack={(() => window.history.back())}
            extra={this.getButtons()}
          />

          {/* Two collections, one view (CD): both lists visible at once, LIVE —
              accepting an invite moves the person from Invited to Active on screen. */}
          <Paragraph strong style={{ marginTop: 8, marginBottom: 4 }}>
            Active users ({(delegatedUsersDataSource || []).length})
          </Paragraph>
          { this.state.loadingDelegatedUsers
            ? <CenteredSpinner loading={this.state.loadingDelegatedUsers} />
            : <Table dataSource={delegatedUsersDataSource} columns={usersColumns} pagination={false} locale={{ emptyText: 'No delegated users yet' }} />
          }

          <Paragraph strong style={{ marginTop: 24, marginBottom: 4 }}>
            Invited — waiting to accept ({(invitedUsersDataSource || []).length})
          </Paragraph>
          { this.state.loadingInvitedUsers
            ? <CenteredSpinner loading={this.state.loadingInvitedUsers} />
            : <Table dataSource={invitedUsersDataSource} columns={invitedUsersColumns} pagination={false} locale={{ emptyText: 'No pending invites' }} />
          }
        </>
      );
    } else if (this.state.mode === 'inviting' || this.state.mode === "saving") {
      return (
        <>
          <PageHeader
            ghost={false}
            title={`Invite user`}
            extra={this.getButtons()}
            tags={this.state.mode === 'saving' && <Tag color="green">Saving...</Tag>}
          />

          <h5>Invited users permissions</h5>

          <ul>
            <li>- Issue withdrawals &amp; create payout methods</li>
            <li>- Manage &amp; edit pages</li>
            <li>- Manage account settings</li>
            <li>- Invite and remove other users</li>
          </ul>

          <Alert
            type="info"
            showIcon
            data-testid="invite-expectations"
            message="What happens next"
            description={
              <>
                <p style={{ marginBottom: 4 }}>
                  We email this address an invite link. It only works for an account
                  signed in with this exact email — Google or Apple sign-in using it
                  counts.
                </p>
                <p style={{ marginBottom: 4 }}>
                  If they don't have a Strikepay account yet, they'll sign up with
                  this email first — the same invite link then works.
                </p>
                <p style={{ marginBottom: 0 }}>
                  Invites are single-use: if you remove their access later, the old
                  link can't be reused.
                </p>
              </>
            }
            style={{ maxWidth: 560, marginBottom: 16 }}
          />

          <br/>

          <Form
            onFinish={this.onFinish}
          >
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  message: 'Please input the email to invite',
                  whitespace: false,
                  type: "email",
                },
              ]}
            >
             <Input/>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">Submit</Button>
            </Form.Item>
          </Form>
        </>
      );
    }
  }
}

